import template from './room-content.html';
import './room-content.scss';

export default angular
  .module('doxy.common.components.roomContent', [])
  .component('roomContent', {
    template,
    bindings: {
      room: '<',
    },
    controller($element, $sce) {
      this.$onInit = () => {
        // Safety check for room and its properties
        if (!this.room || !this.room.widgets) {
          console.warn('roomContent: room or widgets not available');
          return;
        }

        const order = Boolean(this.room.widgetsOrder)
          ? this.room.widgetsOrder.split(',')
          : [];

        this.room.widgets.sort(function (a, b) {
          return order.indexOf(String(a.id)) - order.indexOf(String(b.id));
        });

        // replace sir trevor markdown escape that breaks html links which contain hyphens ('-')
        // https://github.com/doxyme/sir-trevor-custom/blob/master/sir-trevor-custom.js#L6978
        for (const widget of this.room.widgets) {
          if (widget.type === 'text') {
            widget.text = widget.text.replace(/\\-/gu, '-');
          }
        }

        // wait for document ready because sir-trevor is async
        const stateCheck = setInterval(() => {
          if (document.readyState === 'complete') {
            clearInterval(stateCheck);

            // document ready
            const links = $element[0].querySelectorAll('a');
            const isUrl = /^http(s?)/iu;

            // make all links in waiting room open in new tab
            for (let i = 0, linksLength = links.length; i < linksLength; i++) {
              if (isUrl.test(links[i].textContent)) {
                links[i].href = links[i].textContent;
              }
              links[i].target = '_blank';
            }
          }
        }, 500);

        this.room.widgets = this.room.widgets.filter(function (widget) {
          if (
            widget.type === 'image' &&
            widget.imageUrl && widget.imageUrl.includes && !Boolean(widget.imageUrl.includes('https://'))
          ) {
            widget.imageUrl = widget.imageUrl.replace('//', 'https://');
          }

          if (widget.videoSource === 'youtube') {
            const videoId = widget.videoRemoteId.split('&', 1);
            const params = new URLSearchParams(widget.videoRemoteId);
            params.delete(videoId);
            params.append('enablejsapi', 1);
            params.append('autoplay', true);
            widget.youtubeUrl = `https://www.youtube.com/embed/${videoId}?${params}`;
          }

          if (widget.videoSource === 'vimeo') {
            widget.vimeoPlayerUrl = $sce.trustAsResourceUrl(
              `https://player.vimeo.com/video/${widget.videoRemoteId}?autoplay=true`
            );
          }

          return (
            widget.type !== 'video' ||
            widget.videoSource === 'youtube' ||
            widget.videoSource === 'vimeo'
          );
        });
      };
    },
  }).name;
